import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAttentionObservationsById } from "components/axios/equipmentAlertsAxios";
import EquipmentAlertViewMaintenancePage from 'components/inner/EquipmentAlertViewMaintenancePage';

const EquipmentObserveViewMaintenance = () => {

    const {id} = useParams();   // attentionObservation.id

    const [isLoading, setIsLoading] = useState(false);
    const [alertId, setAlertId] = useState(0);

    useEffect(() => {
        equipmentAlertInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[id, isLoading]);

    const equipmentAlertInfo = () => {
        if (id) {
            getAttentionObservationsById(id).then((observe)=>{
                // console.log(observe);
                if (observe) {
                    setAlertId(observe.equipmentAlert.id);
                } else {
                    setAlertId(null);
                }
            }).then((res) => {
                setIsLoading(true);
            })
        }
    }
    
    if (isLoading && alertId) {
        return (
        <EquipmentAlertViewMaintenancePage alertId={alertId}
            linkTarget={"equipment-observe"} setIsLoading={setIsLoading}
        />
        )
    }
}

export default EquipmentObserveViewMaintenance;